import React, { useEffect, useState } from "react";
import Modal from "@mui/material/Modal";
import TextField from "@mui/material/TextField";
import { RxCross1 } from "react-icons/rx";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormLabel from "@mui/material/FormLabel";
import { Formik } from "formik";
import * as Yup from "yup";
import MenuItem from "@mui/material/MenuItem";
import { HttpService } from "../../service/HttpService";
import { toast } from "react-toastify";
import "../Plant/AddForm/../View/View.scss";
import { IoMdAdd } from "react-icons/io";
import DeleteModal from "../Model/DeleteModal";
import "./AddEditMother.scss";
import { Select, Autocomplete } from "@mui/material";

function AddEditMotherPlant({
  open,
  isAdd,
  handleClose,
  rows,
  fetchMotherPlant,
}) {
  const [cultivars, setCultivars] = useState([]);
  const [DeletePlant, setDeletePlant] = useState(false);
  const [deleteItem, setDeleteItem] = useState("");
  const [matricList, setMatricList] = useState([]);
  useEffect(() => {
    const fetchCultivars = async () => {
      try {
        const httpService = new HttpService();
        const res = await httpService.get("plant/get_plant");
        setCultivars(res?.data?.data || []);
      } catch (e) {
        setCultivars([]);
      }
    };
    fetchCultivars();
  }, []);

  useEffect(() => {
    const fetchMatricList = async () => {
      try {
        const httpService = new HttpService();
        const res = await httpService.get("matric/list");
        setMatricList(res?.data || []);
      } catch (e) {
        setMatricList([]);
      }
    };
    fetchMatricList();
  }, []);

  const prefillIds = Array.isArray(rows?.matric_ids)
    ? rows?.matric_ids
    : Array.isArray(rows?.martc_ids)
      ? rows?.martc_ids
      : rows?.mrtrc_ids;

  const handleDeleteItem = (index, values, setFieldValue) => {
    if (values.items.length > 1) {
      const updatedItems = values.items.filter((_, idx) => idx !== index);
      setFieldValue("items", updatedItems);
    } else {
      toast.error("At least one MATRIC ID is required", {
        position: "top-right",
      });
    }
  };

  return (
    <>
      <Modal className="plant-modal" open={open} onClose={handleClose}>
        <Formik
          initialValues={{
            cultivar: rows?.plant_id || "",
            items:
              prefillIds && Array.isArray(prefillIds)
                ? prefillIds.map((id) => ({
                    matric_id: id || "",
                    motherPlantId: id || "",
                    status: "not_ready_to_cut",
                  }))
                : [
                    {
                      matric_id:
                        rows?.matric_id ||
                        rows?.martc_id ||
                        rows?.mrtrc_id ||
                        "",
                      motherPlantId:
                        rows?.matric_id ||
                        rows?.martc_id ||
                        rows?.mrtrc_id ||
                        "",
                      status:
                        rows?.status !== undefined
                          ? rows?.status
                          : "not_ready_to_cut",
                    },
                  ],
          }}
          validationSchema={Yup.object().shape({
            cultivar: Yup.string().required("Please Select Cultivar"),
            items: Yup.array()
              .of(
                Yup.object().shape({
                  motherPlantId: Yup.string().required(
                    "Please select MATRIC ID",
                  ),
                  status: Yup.string().required("Please select a status"),
                }),
              )
              .min(1, "Please add at least one MATRIC ID"),
          })}
          onSubmit={async (values, { setSubmitting, validateForm }) => {
            const errors = await validateForm(values);
            if (Object.keys(errors).length > 0) {
              const firstKey = Object.keys(errors)[0];
              const firstError =
                typeof errors[firstKey] === "string"
                  ? errors[firstKey]
                  : "Please fill all required fields.";
              toast.error(firstError, { position: "top-right" });
              setSubmitting(false);
              return;
            }
            const httpService = new HttpService();
            try {
              if (isAdd) {
                const loggeduser = JSON.parse(localStorage.getItem("user"));
                console.log("values : ", values);

                const promises = values.items.map((item) => {
                  return httpService.post("motherplant/addPlantMother", {
                    plant_id: values.cultivar,
                    matric_id: item.matric_id,
                    status: item.status,
                    date: new Date(),
                    motherPlantId: item.motherPlantId,
                    created_by: loggeduser?.id || 1,
                  });
                });
                await Promise.all(promises);
                toast.success("MotherPlant Added Successfully", {
                  position: "top-right",
                });
              } else {
                const loggeduser = JSON.parse(localStorage.getItem("user"));
                await httpService.put(
                  `motherplant/editPlantMother/${rows.id}`,
                  {
                    matric_ids: values.items.map((item) => ({
                      id: item.id,
                      plant_id: values.cultivar,
                      matric_id: item.matric_id,
                      status: item.status,
                      date: new Date(),
                      motherPlantId: item.motherPlantId,
                      created_by: loggeduser?.id || 1,
                    })),
                  },
                );
                toast.success("MotherPlant Updated Successfully", {
                  position: "top-right",
                });
              }
              fetchMotherPlant && fetchMotherPlant();
              handleClose();
            } catch (error) {
              toast.error(
                error?.response?.data?.error ||
                  error.message ||
                  "Something went wrong.",
                { position: "top-right" },
              );
            }
            setSubmitting(false);
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            setFieldValue,
            isSubmitting,
          }) => (
            <form onSubmit={handleSubmit}>
              <div className="modal_block">
                <div className="modal_header">
                  <div className="modal_title_wrapper">
                    <h2 className="modal_title">
                      {isAdd ? "Add MotherPlant" : "Edit MotherPlant"}
                    </h2>
                  </div>
                  <div className="cancel-btn-wrap">
                    <RxCross1
                      onClick={handleClose}
                      style={{ cursor: "pointer" }}
                    />
                  </div>
                </div>
                <div className="modal_content">
                  <div className="row">
                    <div className="col-md-8">
                      <div className="form_field_wrapper mb-2">
                        <label>
                          Cultivator<span style={{ color: "red" }}>*</span>
                        </label>
                        <FormControl fullWidth>
                          <Select
                            id="cultivar"
                            name="cultivar"
                            value={values.cultivar || ""}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            disabled={!isAdd ? true : false}
                            displayEmpty
                            renderValue={(selected) => {
                              if (!selected) {
                                return (
                                  <span style={{ color: "#999" }}>
                                    Select Cultivar
                                  </span>
                                );
                              }
                              const selectedCultivar = cultivars.find(
                                (item) => item.id === selected,
                              );
                              return selectedCultivar
                                ? selectedCultivar.name
                                : "";
                            }}
                            MenuProps={{
                              anchorOrigin: {
                                vertical: "bottom",
                                horizontal: "left",
                              },
                              transformOrigin: {
                                vertical: "top",
                                horizontal: "left",
                              },
                              keepMounted: true,
                            }}
                          >
                            <MenuItem disabled value="">
                              Select Cultivar
                            </MenuItem>
                            {cultivars.map((cultivar) => (
                              <MenuItem key={cultivar.id} value={cultivar.id}>
                                {cultivar.name}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </div>
                      {touched.cultivar && errors.cultivar ? (
                        <div style={{ color: "red" }}>{errors.cultivar}</div>
                      ) : null}
                    </div>
                    <div className="col-md-12">
                      {values.items?.map((item, index) => (
                        <div
                          key={`mrtrc-row-${index}`}
                          className="row justify-content-between"
                          style={{ alignItems: "center", marginBottom: 12 }}
                        >
                          <div className="col-md-4">
                            <div className="form_field_wrapper m-0">
                              <label>
                                MATRIC ID<span style={{ color: "red" }}>*</span>
                              </label>
                              {/* <TextField
                                id={`items.${index}.matric_id`}
                                name={`items.${index}.matric_id`}
                                placeholder="Enter MATRIC ID"
                                variant="outlined"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.items[index].matric_id}
                                fullWidth
                              /> */}
                              <Autocomplete
                                id={`items.${index}.matric_id`}
                                options={(() => {
                                  const currentVal =
                                    values.items[index].motherPlantId;
                                  const options = [...matricList];
                                  if (
                                    currentVal &&
                                    !options.some(
                                      (o) => o.matric_id === currentVal,
                                    )
                                  ) {
                                    options.push({
                                      id: currentVal,
                                      matric_id: currentVal,
                                    });
                                  }
                                  return options.map((opt) => opt.matric_id);
                                })()}
                                value={values.items[index].motherPlantId || ""}
                                onChange={(event, newValue) => {
                                  const selectedRecord = matricList.find(
                                    (opt) => opt.matric_id === newValue,
                                  );
                                  setFieldValue(
                                    `items.${index}.matric_id`,
                                    selectedRecord ? selectedRecord.id : "",
                                  );
                                  setFieldValue(
                                    `items.${index}.motherPlantId`,
                                    newValue || "",
                                  );
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    placeholder="Search or Select MATRIC ID"
                                    variant="outlined"
                                    fullWidth
                                    onBlur={handleBlur}
                                    name={`items.${index}.motherPlantId`}
                                  />
                                )}
                              />
                            </div>
                            {touched.items &&
                            touched.items[index] &&
                            errors.items &&
                            errors.items[index] &&
                            errors.items[index].motherPlantId ? (
                              <div style={{ color: "red" }}>
                                {errors.items[index].motherPlantId}
                              </div>
                            ) : null}
                          </div>
                          <div className="col-md-6 p-0">
                            <div
                              className="form_field_wrapper mb-2 form_motherpalnt"
                              style={{
                                display: "flex",
                                height: "100%",
                                flexDirection: "column",
                                gap: "4px",
                              }}
                            >
                              <label
                                style={{
                                  paddingLeft: "10px",
                                }}
                              >
                                Status
                              </label>
                              <FormControl fullWidth>
                                {/* <FormLabel
                                  id={`status-label-${index}`}
                                  style={{
                                    fontSize: "14px",
                                    marginBottom: "4px",
                                  }}
                                >
                                  Status
                                </FormLabel> */}
                                <RadioGroup
                                  row
                                  aria-labelledby={`status-label-${index}`}
                                  name={`items.${index}.status`}
                                  value={values.items[index].status}
                                  onChange={(e) =>
                                    setFieldValue(
                                      `items.${index}.status`,
                                      e.target.value,
                                    )
                                  }
                                  style={{
                                    justifyContent: "flex-start",
                                    gap: "16px",
                                    flexWrap: "nowrap",
                                  }}
                                >
                                  <FormControlLabel
                                    value="not_ready_to_cut"
                                    control={
                                      <Radio size="small" color="success" />
                                    }
                                    label="Not Ready to Cut"
                                    style={{ margin: 0, fontSize: "12px" }}
                                  />
                                  <FormControlLabel
                                    value="ready_to_cut"
                                    control={
                                      <Radio size="small" color="warning" />
                                    }
                                    label="Ready to Cut"
                                    style={{ margin: 0, fontSize: "12px" }}
                                  />
                                  <FormControlLabel
                                    value="killed"
                                    control={
                                      <Radio size="small" color="error" />
                                    }
                                    label="Killed"
                                    style={{ margin: 0, fontSize: "12px" }}
                                  />
                                </RadioGroup>
                              </FormControl>
                            </div>
                          </div>
                          <div
                            className="col-md-2 p-0 mt-3"
                            style={{
                              display: "flex",
                              alignItems: "center",
                              height: "100%",
                              justifyContent: "start",
                              zIndex: "99",
                            }}
                          >
                            {/* <button
                            type="button"
                            className="btn btn-border"
                            onClick={() => {
                              const next = values.items.filter(
                                (_op, idx) => idx !== index
                              );
                              setFieldValue("items", next);
                            }}
                          >
                            <RxCross1 />
                          </button> */}
                            <RxCross1
                              onClick={() => {
                                handleDeleteItem(index, values, setFieldValue);
                              }}
                              style={{
                                color: "red",
                                cursor: "pointer",
                                fontSize: "18px",
                                zIndex: "99",
                              }}
                            />
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                  <div
                    className="float-right"
                    style={{
                      display: "flex",
                      justifyContent: "end",
                      alignItems: "center",
                    }}
                  >
                    {isAdd && (
                      <button
                        type="button"
                        onClick={() =>
                          setFieldValue("items", [
                            ...values.items,
                            {
                              matric_id: "",
                              motherPlantId: "",
                              status: "not_ready_to_cut",
                            },
                          ])
                        }
                        className="btn btn-border flex"
                        style={{
                          display: "flex",
                          padding: "6px 12px",
                          justifyContent: "center",
                          alignItems: "center",
                          gap: "10px",
                          borderRadius: "4px",
                          // border: "1px solid var(--Text-text-100, #C0C0C0)",
                        }}
                      >
                        <IoMdAdd
                          className="text-sm"
                          style={{
                            width: "20",
                            height: "20px",
                          }}
                        />
                        <span
                          style={{
                            fontSize: "16px",
                            fontWeight: 500,
                            lineHeight: "20px",
                            letterSpacing: "0em",
                          }}
                        >
                          Add
                        </span>
                      </button>
                    )}
                  </div>
                </div>
                <div className="modal_footer">
                  <button
                    onClick={handleClose}
                    className="btn btn-border"
                    type="button"
                  >
                    Cancel
                  </button>
                  <button
                    className="btn btn-primary"
                    type="submit"
                    disabled={isSubmitting}
                  >
                    {isAdd ? "Save" : "Update"}
                  </button>
                </div>
              </div>
            </form>
          )}
        </Formik>
      </Modal>
      <DeleteModal
        open={DeletePlant}
        HandleClose={() => handleClose()}
        HandleDelete={() => HandleDeletePlant()}
      />
    </>
  );
}

export default AddEditMotherPlant;
